import type { VFC } from 'react';
import { FONT_AWESOME_ICONS } from './constants';
import { StyledIcon, type IconProps } from './StyledIcon';

export const Icon: VFC<IconProps> = props => {
  const { iconString, ...restProps } = props;
  return <StyledIcon icon={FONT_AWESOME_ICONS[iconString]} {...restProps} />;
};
